import { render, staticRenderFns } from "./correctCostPrice.vue?vue&type=template&id=4571ad5e&scoped=true&"
import script from "./correctCostPrice.vue?vue&type=script&lang=js&"
export * from "./correctCostPrice.vue?vue&type=script&lang=js&"
import style0 from "./correctCostPrice.vue?vue&type=style&index=0&id=4571ad5e&lang=less&scoped=true&"
import style1 from "./correctCostPrice.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4571ad5e",
  null
  
)

component.options.__file = "correctCostPrice.vue"
export default component.exports